module.exports = __webpack_public_path__ + "img/2021-03.3db52312.jpg";